import idsTokensDefault from '../../utils/tokens/idsTokens';

export const classes = (idsTokens = idsTokensDefault) => ({
  root: {
    borderRadius: idsTokens.chip.default.radius.standard,
    cursor: 'pointer',
    marginRight: '0.5em',
    padding: `${idsTokens.chip.default.spacing.standard.top} ${idsTokens.chip.default.spacing.standard.right} ${idsTokens.chip.default.spacing.standard.bottom} ${idsTokens.chip.default.spacing.standard.left}`,
    '&.MuiButtonBase-root.MuiChip-root:active': {
      boxShadow: 'none',
    },
    '& .MuiChip-avatar': {
      height: 24,
      width: 24,
      marginLeft: 'unset',
      marginRight: 'unset',
    },
    '& .MuiChip-label': {
      maxWidth: '20ch',
    },
  },
  label: {
    paddingRight: idsTokens.chip.default.spacing.standard.label.right,
    paddingLeft: idsTokens.chip.default.spacing.standard.label.left,
    fontWeight: idsTokens.typography.font.weight.regular,
    lineHeight: idsTokens.typography.lineHeight.base,
    letterSpacing: idsTokens.typography.spacing.letter.lg,
    fontSize: idsTokens.typography.font.size.base,
  },
  icon: {
    fontSize: 19.22,
    boxSizing: 'content-box',
    color: idsTokens.chip.default.color.icon.selected.enabled,
    paddingLeft: idsTokens.chip.default.spacing.standard.icon.left,
    margin: 'unset',
  },
  outlined: {
    boxShadow: 'none',
    border: `1px solid ${idsTokens.chip.default.color.border.unselected.enabled}`,
    padding: `${idsTokens.chip.default.spacing.standard.top} ${idsTokens.chip.default.spacing.standard.right} ${idsTokens.chip.default.spacing.standard.bottom} ${idsTokens.chip.default.spacing.standard.left}`,
    '.MuiChip-clickable&:hover': {
      boxShadow: 'none',
      backgroundColor: idsTokens.chip.default.color.background.unselected.hover,
    },
    '.MuiChip-clickable&:active': {
      boxShadow: 'none',
      backgroundColor: idsTokens.chip.default.color.background.unselected.pressed,
      color: idsTokens.chip.default.color.label.unselected.pressed,
    },
    '&&:focus': {
      backgroundColor: 'unset',
    },
    '& .MuiChip-icon': {
      marginLeft: 'unset',
    },
  },
  filled: {
    border: `1px solid ${idsTokens.chip.default.color.border.selected.enabled}`,
    '.MuiChip-clickable&:hover': {
      boxShadow: 'none',
      backgroundColor: idsTokens.chip.default.color.background.selected.hover,
    },
    '.MuiChip-clickable&:active': {
      boxShadow: 'none',
      backgroundColor: idsTokens.chip.default.color.background.selected.pressed,
      color: idsTokens.chip.default.color.label.selected.pressed,
    },
    '&&:focus': {
      backgroundColor: 'unset',
    },
    '& .MuiChip-icon': {
      marginLeft: 'unset',
    },
  },
  deletable: {
    '&:focus': 'unset',
  },
  deleteIcon: {
    marginRight: 'unset',
    marginLeft: `calc(-${idsTokens.chip.default.spacing.standard.label.right} / 4)`,
  },
  sizeSmall: {
    height: `calc(${idsTokens.chip.default.sizing.small.height} - 2px)`,
    borderRadius: idsTokens.chip.default.radius.small,
    boxSizing: 'content-box',
    padding: `${idsTokens.chip.default.spacing.small.top} ${idsTokens.chip.default.spacing.small.right} ${idsTokens.chip.default.spacing.small.bottom} ${idsTokens.chip.default.spacing.small.left}`,
  },
  labelSmall: {
    fontSize: idsTokens.typography.font.size.sm,
    fontWeight: idsTokens.typography.font.weight.regular,
    lineHeight: idsTokens.typography.lineHeight.sm,
    letterSpacing: idsTokens.typography.spacing.letter.md,
    paddingRight: idsTokens.chip.default.spacing.small.label.right,
    paddingLeft: idsTokens.chip.default.spacing.small.label.left,
    paddingTop: 'unset',
    paddingBottom: 2,
  },
  deleteIconSmall: {
    padding: '0px 2.1px 0px 3.1px',
    width: idsTokens.chip.default.sizing.small.icon,
    height: idsTokens.chip.default.sizing.small.icon,
    marginLeft: `-${idsTokens.chip.default.spacing.small.label.left}`,
  },
  iconSmall: {
    height: idsTokens.chip.default.sizing.small.icon,
    width: 16.8,
    paddingLeft: idsTokens.chip.default.spacing.small.icon.left,
    marginLeft: 'unset',
    marginRight: 'unset',
  },
});
